<template>
  <RefundSkeleton v-if="loading" />
  <div v-else class="card-content">
    <div class="card-content-item">
      <div class="card-content-result">
        <div class="result-row">
          <a :href="TEST_SO_N11 + '/selleroffice/v2/product/products?tab=on_sale'">
          <span>Satışta</span>
          <strong class="card-count">{{refundData.onSale}}</strong>
        </a>
        
        </div>
      </div>
    </div>

    <div class="card-content-item">
      <div class="card-content-result">
        <a
          :href="
            TEST_SO_N11 + '/selleroffice/v2/product/products?tab=pending_approvals'
          "
        >
          <span>Katalog Onayında</span>
          <strong class="card-count">{{refundData.waitingForApproval}}</strong>
        </a>
      </div>
    </div>

    <div class="card-content-item">
        <div class="card-content-result">
        <a
        :href="
              TEST_SO_N11 +
              '/selleroffice/v2/product/products?tab=not_on_sale'
            "
        >
          <span>Satışta Olmayan</span>
          <strong class="card-count">{{refundData.notOnSale}}</strong>
        </a>
      </div>  
      </div>

    <div class="card-content-item">
      <div class="card-content-result">
        <a
          :href="
            TEST_SO_N11 + '/selleroffice/v2/product/products?tab=sold'
          "
        >
          <span>Tükendi</span>
          <strong class="card-count">{{ refundData.outOfStock }}</strong>
        </a>
      </div> 
    </div>
  </div>

</template>


<script setup>
import RefundSkeleton from '@/components/RefundCard/RefundSkeleton.vue';
import { ENVIRONMENT_HOSTS } from '@/utils/enum/enviromentHosts';

const props = defineProps({
  refundData: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const TEST_SO_N11 = ENVIRONMENT_HOSTS.TEST_SO_N11;
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

.hr {
  width: 90%;
  margin: 10px 0;
}

.card-content-item {
  flex-grow: 0 !important;
  flex-basis: calc(50% - 10px) !important;
  width: calc(50% - 10px) !important;
}

.card-content-result {
  strong {
    margin-bottom: 6px;
    white-space: nowrap;
  }
  span{
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    color: $colorM50;
  }
  .card-count{
    width: 179px;
    height: 34px;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px;
    color : $colorN80;
  }
}

.card-footer-item{
  gap: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
   strong{
    margin-left: 0;
   }
}

.result-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: -130px;
  margin-bottom: 10px;
}
</style>
